import { Typography } from '@evaneos/b2b-ui';
import PeopleIcon from '@evaneos/b2b-ui/icons/PeopleAltOutlined';
import { useIntl } from 'react-intl';

import { DefinitionList } from '../../../design-system/DefinitionList/DefinitionList';
import { ChildrenAges, Participants } from '../../../resources/dossier/types';
import { useDossierLayoutInfo } from '../DossierLayoutInfoContext';

type ParticipantsInfoProps = {
    participants: Participants;
    requesterAge?: number | null;
};

export function formatAges(ages: ChildrenAges | null, formatter: (age: number) => string): string {
    if (!ages || ages.length === 0) {
        return '';
    }

    return `(${ages.map(formatter).join(' - ')})`;
}

export function ParticipantsInfo({ participants, requesterAge }: ParticipantsInfoProps) {
    const { formatMessage } = useIntl();
    const { isFirstColumnNarrow } = useDossierLayoutInfo();

    const ageFormatter = (age: number) =>
        formatMessage({ id: 'dossier.participants.children_ages' }, { childrenAge: age });

    return (
        <DefinitionList.Item>
            <DefinitionList.Label
                id="number-of-travellers"
                icon={<PeopleIcon fontSize="small" aria-hidden="true" />}
                iconOnly={isFirstColumnNarrow}
            >
                {formatMessage({
                    id: 'dossier.information.number_of_travellers',
                })}
            </DefinitionList.Label>
            <DefinitionList.StaticValue>
                <Typography variant="body2">
                    {formatMessage(
                        { id: 'dossier.participants.counter' },
                        {
                            ...participants.number,
                            mainTravelerAge:
                                requesterAge &&
                                formatMessage(
                                    { id: 'dossier.information.initial_request.requester_age' },
                                    { age: ageFormatter(requesterAge) },
                                ),
                            teenagersAges:
                                participants.childrenAges &&
                                formatAges(participants.childrenAges.teenagers, ageFormatter),
                            childrenAges:
                                participants.childrenAges &&
                                formatAges(participants.childrenAges.children, ageFormatter),
                            babiesAges:
                                participants.childrenAges &&
                                formatAges(participants.childrenAges.babies, ageFormatter),
                        },
                    )}
                </Typography>
            </DefinitionList.StaticValue>
        </DefinitionList.Item>
    );
}
